(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-media')) {
    customElements.define(
      'product-card-media',
      class ProductCardMedia extends HTMLElement {
        // One observer also covers saved grid modes, sliders and AJAX-inserted cards.
        static resizeObserver = new ResizeObserver((entries) => {
          for (const { target, contentRect } of entries) {
            if (contentRect.width <= 0) continue;

            const sizes = `${Math.ceil(contentRect.width)}px`;
            for (const image of target.querySelectorAll('img[srcset]')) {
              const imageSizes = image.loading === 'lazy' ? `auto, ${sizes}` : sizes;
              if (image.sizes !== imageSizes) image.sizes = imageSizes;
            }
          }
        });

        // Grid cards (shared_markup) ship slides 2-3 as <img data-src> without srcset. They load once the card is on
        // screen and its first image has finished, so they never compete with first-row images, or at once on the
        // first touch or hover so a swipe never shows an empty slide.
        static slideWidths = [240, 320, 400, 480, 600, 750, 900, 1100, 1350]; // = card_image_widths for shared_markup

        static slideObserver =
          'IntersectionObserver' in window
            ? new IntersectionObserver((entries) => {
                for (const { target, isIntersecting } of entries) {
                  if (isIntersecting) target.loadSlidesAfterFirstImage();
                }
              })
            : null;

        loadSlides = () => {
          this.removeEventListener('touchstart', this.loadSlides);
          this.removeEventListener('pointerover', this.loadSlides);
          this.constructor.slideObserver?.unobserve(this);
          for (const image of this.querySelectorAll('img[data-src]')) {
            const url = new URL(image.dataset.src, window.location.href);
            const sourceWidth = Number(image.getAttribute('width')) || Infinity;
            const widths = this.constructor.slideWidths.filter((width) => width <= sourceWidth);
            if (!widths.length) widths.push(sourceWidth);
            image.srcset = widths
              .map((width) => {
                url.searchParams.set('width', width);
                return `${url.href} ${width}w`;
              })
              .join(', ');
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
          }
        };

        loadSlidesAfterFirstImage() {
          this.constructor.slideObserver.unobserve(this);
          const firstImage = this.querySelector('img[srcset]');
          if (!firstImage || firstImage.complete) return this.loadSlides();
          firstImage.addEventListener('load', this.loadSlides, { once: true });
          firstImage.addEventListener('error', this.loadSlides, { once: true });
        }

        connectedCallback() {
          this.constructor.resizeObserver.observe(this);
          if (!this.querySelector('img[data-src]')) return;
          this.addEventListener('touchstart', this.loadSlides, { passive: true });
          this.addEventListener('pointerover', this.loadSlides, { passive: true });
          if (this.constructor.slideObserver) this.constructor.slideObserver.observe(this);
          else this.loadSlides();
        }

        disconnectedCallback() {
          this.constructor.resizeObserver.unobserve(this);
          this.constructor.slideObserver?.unobserve(this);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf04-promise-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (customElements.get('pf04-promise-carousel')) return;

    // VARIATION 1 DATA - Duplicated for smooth infinite loop
    const slidesV1Base = [
      {
        title: 'The Origin',
        navText: 'Week 1',
        description:
          'Family-owned and Philadelphia-designed, Printfresh brings hand-drawn artwork to life with ethical artisan partners in Jaipur.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v1-v2-v3-img1.png?v=1760949791',
      },
      {
        title: 'The Fit',
        navText: 'Week 2',
        description:
          'Every detail is intentional. Contrast piping, thoughtfully placed pockets, and silhouettes that balance ease with elegance. Available from XXS-6X with petite and tall options, each piece is polished without sacrificing comfort.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v1-img2.png?v=1760949791',
      },
      {
        title: 'The Materials',
        navText: 'Month 3',
        description:
          "Whether it's crisp organic cotton poplin, silky satin viscose, or cozy flannel, there's a style for everyone. Sustainably sourced fabrics are crafted to last wear after wear, while recycled mailers mean your favorites are delivered the eco-friendly way.",
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v1-img3.png?v=1760949791',
      },
      {
        title: 'The Longevity',
        navText: 'Day 365',
        description:
          'Wash, wear, repeat–Printfresh styles are designed to get softer with every cycle. Colors stay bright, shapes stay true, and prints keep their charm for years, not a season.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v1-v4-img4.png?v=1760949791',
      },
    ];
    // Duplicate slides twice for smooth infinite loop
    const slidesV1 = [...slidesV1Base, ...slidesV1Base];

    // VARIATION 2 DATA - Duplicated for smooth infinite loop
    const slidesV2Base = [
      {
        title: 'The Art',
        navText: 'Week 1',
        description: 'Inspired by travel, nature, and customer requests, our hand-drawn patterns are true works of art.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v1-v2-v3-img1.png?v=1760949791',
      },
      {
        title: 'The Feel',
        navText: 'Week 2',
        description: 'Breathable fabric gets softer with every wash. Comfort you can count on, season after season.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v2-img4.png?v=1760949791',
      },
      {
        title: 'The Versatility',
        navText: 'Month 3',
        description:
          'From slow mornings at home to faraway getaways, experience unmatched comfort. Thoughtful details and inclusive sizing make self-care effortless wherever you are.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v2-img3.png?v=1760949791',
      },
      {
        title: 'The Joy',
        navText: 'Month 6',
        description:
          'Prints that spark conversation, lift the mood, and make gifting feel special. Confidence you can slip on–the kind that turns everyday moments into little celebrations.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/The_Joy_2x_397dad01-4294-4316-ba18-151be38bbc77.png?v=1760950339',
      },
    ];
    // Duplicate slides twice for smooth infinite loop
    const slidesV2 = [...slidesV2Base, ...slidesV2Base];

    // VARIATION 3 DATA - Duplicated for smooth infinite loop
    const slidesV3Base = [
      {
        title: 'The Inspiration',
        navText: 'Step 1',
        description:
          'Dreamed up in our Philadelphia studio and inspired by travel, nature, and your ideas, our hand-painted prints are transformed into hand-screen-printed works of art.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v1-v2-v3-img1.png?v=1760949791',
      },
      {
        title: 'The Fabric',
        navText: 'Step 2',
        description:
          'We work with materials that suit the moment–organic cotton poplin for crisp coolness, satin viscose for a silky drape, flannel for cozy nights–always chosen for color, feel, and longevity.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v3-img2.png?v=1760949791',
      },
      {
        title: 'The Craft',
        navText: 'Step 3',
        description:
          'Prints are hand screen-printed in small batches by ethically conscious partners in Jaipur, India, then finished with considerate details–contrast piping, thoughtfully placed pockets, and polished silhouette.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v3-img3.png?v=1760949791',
      },
      {
        title: 'Care & Longevity',
        navText: 'Step 4',
        description:
          'Our pieces are made to be lived in and loved—softening over time while maintaining their signature quality and color for years to come.',
        image: 'https://cdn.shopify.com/s/files/1/1543/8719/files/pf04-v1-v4-img4.png?v=1760949791',
      },
    ];
    // Duplicate slides twice for smooth infinite loop
    const slidesV3 = [...slidesV3Base, ...slidesV3Base];

    // Construct slides only after this variation is visible and near the viewport.
    function initSwiper(variation, variationId, slidesData) {
      const container = variation.querySelector('.pf-swiper-container');
      const descriptionText = variation.querySelector('.carousel-description');
      const wrapper = container.querySelector('.swiper-wrapper');

      if (!wrapper.querySelector('.swiper-slide')) {
        wrapper.innerHTML = slidesData
          .map(
            (slide, index) => `
        <div class="swiper-slide pf-swiper-slide" data-index="${index}">
          <div class="pf-swiper-slide-content">
            <img src="${slide.image}" alt="${slide.title}">
            <div class="pf-swiper-slide__title">${slide.title}</div>
          </div>
        </div>
      `,
          )
          .join('');
      }

      return new Swiper(container, {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        loopAdditionalSlides: 2,
        loopedSlides: 4,
        initialSlide: 0,
        speed: 600,
        observer: false,
        observeParents: false,
        resizeObserver: false,
        updateOnWindowResize: false,
        watchOverflow: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 150,
          modifier: 1.5,
          slideShadows: false,
        },
        navigation: {
          nextEl: variation.querySelector('.swiper-button-next-' + variationId),
          prevEl: variation.querySelector('.swiper-button-prev-' + variationId),
        },
        breakpoints: {
          // Mobile
          320: {
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 1.2,
              slideShadows: false,
            },
          },
          // Desktop
          769: {
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 150,
              modifier: 1.5,
              slideShadows: false,
            },
          },
        },
        on: {
          slideChange: function () {
            // Update description text based on real index
            // Use modulo to map back to original 4 slides since we duplicated them
            const baseLength = slidesData.length / 2;
            const realIndex = this.realIndex % baseLength;
            descriptionText.textContent = slidesData[realIndex].description;
          },
          init: function () {
            // Set initial description
            descriptionText.textContent = slidesData[0].description;
          },
        },
      });
    }

    class PF04PromiseCarousel extends HTMLElement {
      frame = null;
      variations = [];

      connectedCallback() {
        if (this.abortController) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.intersectionObserver = new IntersectionObserver(this.scheduleSync, { rootMargin: '400px' });
        this.resizeObserver = new ResizeObserver(this.scheduleSync);
        this.mutationObserver = new MutationObserver(this.scheduleSync);

        // Experiments may toggle the variation itself or a class/style on an ancestor.
        // Watch direct children during parsing, but not Swiper's own slide mutations.
        for (let ancestor = this; ancestor; ancestor = ancestor.parentElement) {
          this.mutationObserver.observe(ancestor, {
            attributes: true,
            childList: ancestor === this,
            attributeFilter: ['class', 'style', 'hidden'],
          });
        }

        this.addEventListener('load', this.scheduleSync, { signal, capture: true });
        window.addEventListener('resize', this.scheduleSync, { signal, passive: true });
        window.addEventListener('load', this.scheduleSync, { signal, once: true });
        this.closest('.shopify-section')?.addEventListener('shopify:section:unload', this.teardown, { signal });

        // A registered element can connect while its children are still being parsed.
        this.scheduleSync();
      }

      disconnectedCallback() {
        this.teardown();
      }

      scheduleSync = () => {
        if (!this.abortController || this.frame !== null) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.syncVariations();
        });
      };

      isVisible(variation) {
        if (!variation.getClientRects().length) return false;

        return variation.checkVisibility
          ? variation.checkVisibility({ visibilityProperty: true })
          : getComputedStyle(variation).visibility === 'visible';
      }

      syncVariations() {
        if (!this.isConnected || !this.abortController) return;

        if (!this.variations.length) {
          const slides = [slidesV1, slidesV2, slidesV3];
          const elements = slides.map((_, index) => this.querySelector('.pf04-variation-' + (index + 1)));
          if (elements.some((element) => !element)) return;

          for (let index = 0; index < slides.length; index++) {
            const variation = elements[index];

            this.variations.push({ element: variation, id: 'v' + (index + 1), slides: slides[index], swiper: null });
            this.intersectionObserver.observe(variation);
            this.resizeObserver.observe(variation);
            this.mutationObserver.observe(variation, {
              attributes: true,
              attributeFilter: ['class', 'style', 'hidden'],
            });
          }
        }

        for (const variation of this.variations) {
          if (!this.isVisible(variation.element)) {
            if (variation.swiper?.enabled) variation.swiper.disable();
            continue;
          }

          const rect = variation.element.getBoundingClientRect();

          if (!variation.swiper) {
            // Recheck geometry rather than trusting a stale intersection after a toggle.
            if (rect.bottom < -400 || rect.top > window.innerHeight + 400) continue;
            if (typeof Swiper === 'undefined') {
              this.loading ||= window.pfLoadSwiper?.().then(this.scheduleSync, () => {});
              continue;
            }

            variation.swiper = initSwiper(variation.element, variation.id, variation.slides);
          } else if (
            !variation.swiper.enabled ||
            variation.width !== rect.width ||
            variation.height !== rect.height ||
            variation.viewportWidth !== window.innerWidth
          ) {
            variation.swiper.enable();
            variation.swiper.update();
          }

          variation.width = rect.width;
          variation.height = rect.height;
          variation.viewportWidth = window.innerWidth;
        }
      }

      teardown = () => {
        this.abortController?.abort();
        this.abortController = null;
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.intersectionObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();

        for (const variation of this.variations) {
          variation.swiper?.destroy(true, true);
        }

        this.variations = [];
      };
    }

    customElements.define('pf04-promise-carousel', PF04PromiseCarousel);
  })();
  } catch(e) { console.error(e); }
})();

})();
